/** Strings of the app download pages, the phone scanner, the terminal connect page, the nav labels and shared UI/lib bits. */
export const miscBEn = {
  miscDownload: {
    copy: "Copy",
    copied: "Copied",
    intro:
      "Hub's agents in your own terminal, the way you work with Claude Code. Hub is this web app; lair is what runs on your machine.",
    install:
      "Paste it into a terminal. It installs the <code>lair</code> command into <code>~/.local</code> and walks you through the setup; run it again any time to update. Needs Node.js 20+, git and <claude>Claude Code</claude> signed in.",
    whatItDoes: "What it does",
    theSetup: "The setup",
    commands: "Commands",
    more: "More in the wiki: Agenti v terminálu. The token the app gets is listed in Profile → API tokens, where you can revoke it.",
    features: {
      planner: {
        title: "Plan with the planner",
        body: "<code>lair planner</code> opens a planning conversation about the project you're in: ideas, new or reworked tickets, a plan ready to build. It checks things for itself first: reads files, runs curl or a browser, searches the web. Everything it changes in Hub lands on the Planner tab with an undo.",
      },
      developer: {
        title: "Give the developer a task",
        body: 'The command <code>lair developer "add a CSV export"</code> files the ticket under your name, gives it a branch and opens a developer on it in a new terminal window, in a worktree of its own. The planner and the developer can do the same mid-conversation; <code>lair developer 1234</code> opens a ticket you already hold. The developer works with you; Metoděj is Hub\'s own agent that builds on the server.',
      },
      creator: {
        title: "Start a new project with the creator",
        body: "<code>lair creator</code> talks a brand-new project through with you: you describe it and hand over the materials, it asks, researches and plans it with you. Once you agree, it creates the project in Hub with its repo, writes the wiki and opens the releases and first tickets. For Hub admins.",
      },
      audit: {
        title: "Independent audit",
        body: "Every step is checked by a fresh session that never sees how the work was described. Only an accepted step is committed, pushed and marked verified.",
      },
      mr: {
        title: "Merge request under your name",
        body: "When every step is verified, the app opens the merge request with your git identity and moves the ticket to its merge gate. Merging (Vratislav) and testing (Prokop) stay on Hub.",
      },
      takeover: {
        title: "Take over and hand back",
        body: "Take a ticket's development over from Metoděj when he isn't working on it, finish it in your terminal, or hand it back: he carries on from the same branch.",
      },
      openFromHub: {
        title: "Open from Hub",
        body: "Open in lair on a ticket, on the Planner tab or on a new project starts the right agent as a chat in lair's window, already in the right project. lair starts if it isn't running.",
      },
      watch: {
        title: "Watch the agents",
        body: "On a ticket an agent is working on, Watch shows what it runs and says, live. Watching costs the agent nothing.",
      },
      skills: {
        title: "The team's skills",
        body: "Installs and keeps up to date the team's Claude Code skills from the netlion marketplace: Hub tickets, Grafana logs, pipelines, screenshots and more.",
      },
      tracker: {
        title: "Time tracking (optional)",
        body: "Every ten minutes it sends your Claude Code conversations and commits to Hub, which proposes the time entries for you to approve. It counts work done outside the app too.",
      },
      subscription: {
        title: "Your subscription, your name",
        body: "The agents think on your own Claude login, never on Hub's. They act as you, within the limits each agent has on the server, and everything is logged.",
      },
    },
    setup: {
      folder: "Asks where your project clones live (it suggests the folder with the most of them).",
      signIn:
        "Signs you in: Hub opens a page with a code, you check it matches and press Allow. No token to copy.",
      links:
        "Registers lair:// links so the Open in lair buttons open the agent in lair (Linux and macOS).",
      skills: "Installs the team's skills for Claude Code, or updates them.",
      tracker:
        "Optionally schedules the time tracker (a systemd timer on Linux, a LaunchAgent on macOS).",
    },
    cmd: {
      lair: "pick the agent, then the project or ticket",
      planner: "plan the project; without one, pick (this folder's repo is the default)",
      developerNew: "a new ticket for this repo, a developer on it in a new window",
      developerTicket: "build a ticket you hold; without one, pick from yours",
      creator: "plan a new project together, then create it in Hub with its repo",
      trackerSync: "send the time-tracking evidence now (it runs every ten minutes anyway)",
      setup: "set this machine up again",
      update: "update now; lair also updates itself in the background",
      configProjectsDir: "where your project clones live",
    },
  },
  miscScanner: {
    title: "Netlion Scanner",
    intro:
      "The Android app for receipts and invoices: photograph, send, done. It does nothing else.",
    download: "Download for Android",
    step1: "Open this page on the phone, or scan the code.",
    step2: "Download the app and open the file; Android asks to allow installing it once.",
    step3: "Sign in with GitLab, the same as in Hub.",
    qrAlt: "QR code with the download link",
    features: {
      photograph: {
        title: "Photograph",
        body: "One big button opens the phone's camera. Shoot the whole receipt or invoice.",
      },
      cleanup: {
        title: "Cleaned up on its own",
        body: "The app finds the sheet, crops and straightens it, turns it upright and evens out the light. Rotate by hand or send the original if it guessed wrong.",
      },
      send: {
        title: "Send",
        body: "The document lands in accounting's inbox, where its details are read and an accountant confirms them.",
      },
      offline: {
        title: "Works without a signal",
        body: "Photos wait on the phone and leave by themselves once it is back online.",
      },
      recent: {
        title: "Recently sent",
        body: "The list of your last documents and how far each one got: being read, waiting for the accountant, in the books.",
      },
    },
  },
  miscScan: {
    title: "Netlion Scanner",
    update:
      "A new version of Netlion Scanner is ready. Tap to download it, then confirm the install.",
    offline:
      "The phone is offline. Keep shooting, documents wait on the phone and leave on their own.",
    photoAlt: "Photographed document",
    rotate: "Rotate",
    showCleaned: "Show cleaned up",
    showOriginal: "Show original",
    working: "Working…",
    send: "Send",
    retake: "Retake",
    processing: "Processing…",
    photograph: "Photograph a document",
    waiting: "Waiting to be sent: {{count}}",
    tryAgain: "Try again",
    recently: "Recently sent",
    sent: "Sent ({{sent}}).",
    sentSome: "Sent {{sent}}, {{remaining}} waiting.",
    notSent: "Not sent yet, {{remaining}} waiting. They leave on their own once there is a signal.",
    processFailed: "Couldn't process the photo. Please try again.",
    saved: "Saved. Sending…",
    saveFailed: "Couldn't save it on this phone.",
    status: {
      pending: "Being read",
      extracted: "Read, waiting for the accountant",
      failed: "Couldn't be read, the accountant will fill it in",
      filed: "In the books",
      discarded: "Discarded",
    },
  },
  miscConnect: {
    title: "Connect lair",
    description: "A terminal asks to act as you: Hub's agents on your own Claude subscription.",
    expired: "This request has expired or was already answered. Run <code>lair setup</code> again.",
    allowed: "Done. Go back to your terminal, it carries on by itself.",
    denied: "Refused. The terminal gets nothing.",
    code: "Code shown in the terminal",
    onHost: "on {{host}}",
    ableTo: "It will be able to:",
    skillsAbleTo: "Claude Code's skills (hub) get their own key and will be able to:",
    warning:
      "Allow it only if you started it and the code matches. You can revoke it any time in Profile → API tokens.",
    allow: "Allow",
    deny: "Deny",
    answerFailed: "Couldn't answer the request.",
  },
  miscNav: {
    getLair: "Get lair",
    getScanner: "Get Netlion Scanner",
    labels: {
      myPage: "My Page",
      projects: "Projects",
      workItems: "Work Items",
      wiki: "Wiki",
      ideas: "Ideas",
      testMail: "Test mail",
      activity: "Activity",
      myTime: "My Time",
      timeSuggestions: "Time Suggestions",
      customers: "Customers",
      billing: "Billing",
      aiSpend: "AI Spend",
      accounting: "Accounting",
      overview: "Overview",
      invoices: "Invoices",
      recurring: "Recurring",
      expenses: "Expenses",
      inbox: "Inbox",
      bank: "Bank",
      missingDocuments: "Missing documents",
      taxDocuments: "Tax documents",
      dataBox: "Data box",
      cash: "Cash",
      contacts: "Contacts",
      settings: "Settings",
      leavingFakturoid: "Leaving Fakturoid",
      books: "Books",
      receivables: "Receivables",
      journal: "Journal",
      openingBalances: "Opening balances",
      vat: "VAT",
      assets: "Assets",
      statements: "Statements",
      analytics: "Analytics",
      alerts: "Alerts",
      users: "Users",
      agents: "Agents",
      suggestions: "Suggestions",
      review: "Review",
      learnings: "Learnings",
      timeEntries: "Time Entries",
      entries: "Entries",
      sync: "Sync",
    },
  },
  miscUi: {
    loading: "Loading",
    clearFilter: "Clear filter",
    include: "Include",
    exclude: "Exclude",
    selectedCount: "{{count}} selected",
    excludedCount: "{{count}} excluded",
    noChanges: "No changes.",
    copyToast: "Copy toast contents",
    imagePreview: "Image preview",
  },
  miscLib: {
    genericError: "Something went wrong. Please try again.",
    restarting:
      "Hub is restarting (probably an update going out). Nothing was lost, try again in a moment.",
    gitlabRejected: "GitLab rejected the change.",
    applyFailed: "Couldn't apply this suggestion.",
    workItemHint: "Work item",
    overheadHint: "Overhead",
    closedSuffix: " (closed)",
    defaultSuffix: " (default)",
    title: {
      dashboard: "Dashboard",
      activity: "Activity",
      profile: "Profile",
      reports: "Reports",
      newTimeEntry: "New time entry",
      timeEntries: "Time entries",
      newFeature: "New feature",
      newBug: "New bug",
      newTask: "New task",
      newWorkItem: "New work item",
      workItem: "Work item",
      workItems: "Work items",
      newProject: "New project",
      projectSettings: "Project settings",
      projectMembers: "Project members",
      releases: "Releases",
      wiki: "Wiki",
      project: "Project",
      projects: "Projects",
      newCustomer: "New customer",
      editCustomer: "Edit customer",
      customer: "Customer",
      customers: "Customers",
      idea: "Idea",
      ideas: "Ideas",
      newInvoice: "New invoice",
      invoice: "Invoice",
      billing: "Billing",
      myPage: "My page",
      user: "User",
      users: "Users",
      syncRun: "Sync run",
      sync: "Sync",
    },
  },
};

export const miscBCs: typeof miscBEn = {
  miscDownload: {
    copy: "Kopírovat",
    copied: "Zkopírováno",
    intro:
      "Agenti Hubu ve vašem vlastním terminálu, tak jak pracujete s Claude Code. Hub je tato webová aplikace; lair je to, co běží na vašem počítači.",
    install:
      "Vložte ho do terminálu. Nainstaluje příkaz <code>lair</code> do <code>~/.local</code> a provede vás nastavením; kdykoli ho spusťte znovu pro aktualizaci. Potřebuje Node.js 20+, git a přihlášený <claude>Claude Code</claude>.",
    whatItDoes: "Co umí",
    theSetup: "Nastavení",
    commands: "Příkazy",
    more: "Víc ve wiki: Agenti v terminálu. Token, který aplikace dostane, najdete v Profilu → API tokeny, kde ho můžete zrušit.",
    features: {
      planner: {
        title: "Plánujte s plánovačem",
        body: "<code>lair planner</code> otevře plánovací rozhovor o projektu, ve kterém jste: nápady, nové nebo přepracované tikety, plán připravený k realizaci. Nejdřív si věci ověří sám: čte soubory, spouští curl nebo prohlížeč, hledá na webu. Všechno, co v Hubu změní, skončí na záložce Plánovač s možností vrácení.",
      },
      developer: {
        title: "Zadejte vývojáři úkol",
        body: 'Příkaz <code>lair developer "add a CSV export"</code> založí tiket na vaše jméno, vytvoří mu větev a otevře na něm vývojáře v novém okně terminálu, ve vlastním worktree. Plánovač a vývojář umí totéž uprostřed rozhovoru; <code>lair developer 1234</code> otevře tiket, který už držíte. Vývojář pracuje s vámi; Metoděj je vlastní agent Hubu, který staví na serveru.',
      },
      creator: {
        title: "Založte nový projekt s tvůrcem",
        body: "<code>lair creator</code> probere s vámi zcela nový projekt: popíšete ho a předáte podklady, on se ptá, zjišťuje informace a plánuje s vámi. Jakmile se dohodnete, vytvoří projekt v Hubu i s repozitářem, napíše wiki a založí releasy a první tikety. Pro adminy Hubu.",
      },
      audit: {
        title: "Nezávislá kontrola",
        body: "Každý krok kontroluje nová session, která nikdy nevidí, jak byla práce popsána. Jen schválený krok se commitne, pushne a označí jako ověřený.",
      },
      mr: {
        title: "Merge request na vaše jméno",
        body: "Když je každý krok ověřený, aplikace otevře merge request s vaší git identitou a přesune tiket do slučovací brány. Slučování (Vratislav) a testování (Prokop) zůstávají v Hubu.",
      },
      takeover: {
        title: "Převzít a předat zpět",
        body: "Převezměte vývoj tiketu od Metoděje, když na něm nepracuje, dokončete ho ve svém terminálu, nebo ho předejte zpět: naváže na stejné větvi.",
      },
      openFromHub: {
        title: "Otevřít z Hubu",
        body: "Otevřít v lair na tiketu, na záložce Plánovač nebo u nového projektu spustí správného agenta jako chat v okně lair, rovnou ve správném projektu. Pokud lair neběží, spustí se.",
      },
      watch: {
        title: "Sledujte agenty",
        body: "U tiketu, na kterém agent pracuje, Sledovat ukazuje živě, co spouští a říká. Sledování agenta nic nestojí.",
      },
      skills: {
        title: "Dovednosti týmu",
        body: "Nainstaluje a udržuje aktuální dovednosti týmu pro Claude Code z marketplace netlion: tikety v Hubu, logy z Grafany, pipeliny, screenshoty a další.",
      },
      tracker: {
        title: "Sledování času (volitelné)",
        body: "Každých deset minut posílá vaše konverzace s Claude Code a commity do Hubu, který z nich navrhne časové záznamy ke schválení. Počítá i práci mimo aplikaci.",
      },
      subscription: {
        title: "Vaše předplatné, vaše jméno",
        body: "Agenti myslí na vašem vlastním přihlášení ke Claude, nikdy na přihlášení Hubu. Jednají za vás, v mezích, které má každý agent na serveru, a všechno se zaznamenává.",
      },
    },
    setup: {
      folder: "Zeptá se, kde máte naklonované projekty (navrhne složku, kde jich je nejvíc).",
      signIn:
        "Přihlásí vás: Hub otevře stránku s kódem, zkontrolujete, že souhlasí, a stisknete Povolit. Žádný token nekopírujete.",
      links:
        "Zaregistruje odkazy lair://, aby tlačítka Otevřít v lair otevřela agenta v lair (Linux a macOS).",
      skills: "Nainstaluje dovednosti týmu pro Claude Code, nebo je aktualizuje.",
      tracker:
        "Volitelně naplánuje sledování času (systemd timer na Linuxu, LaunchAgent na macOS).",
    },
    cmd: {
      lair: "vyberte agenta, potom projekt nebo tiket",
      planner: "naplánujte projekt; bez zadání vyberete (výchozí je repozitář této složky)",
      developerNew: "nový tiket pro tento repozitář, vývojář na něm v novém okně",
      developerTicket: "zpracujte tiket, který držíte; bez zadání vyberete z vašich",
      creator: "společně naplánujte nový projekt a pak ho vytvořte v Hubu i s repozitářem",
      trackerSync: "odešle podklady pro sledování času hned (jinak běží každých deset minut)",
      setup: "nastaví tento počítač znovu",
      update: "aktualizuje hned; lair se aktualizuje i sám na pozadí",
      configProjectsDir: "kde máte naklonované projekty",
    },
  },
  miscScanner: {
    title: "Netlion Scanner",
    intro: "Android aplikace na účtenky a faktury: vyfotit, odeslat, hotovo. Nic jiného nedělá.",
    download: "Stáhnout pro Android",
    step1: "Otevřete tuto stránku v telefonu, nebo naskenujte kód.",
    step2:
      "Stáhněte aplikaci a otevřete soubor; Android se jednorázově zeptá, zda povolit instalaci.",
    step3: "Přihlaste se přes GitLab, stejně jako v Hubu.",
    qrAlt: "QR kód s odkazem ke stažení",
    features: {
      photograph: {
        title: "Vyfotit",
        body: "Jedno velké tlačítko otevře fotoaparát telefonu. Vyfoťte celou účtenku nebo fakturu.",
      },
      cleanup: {
        title: "Upraví se sama",
        body: "Aplikace najde list, ořízne ho a narovná, otočí do správné polohy a vyrovná světlo. Otočte ručně, nebo pošlete originál, pokud se spletla.",
      },
      send: {
        title: "Odeslat",
        body: "Doklad skončí v příchozí poště účetnictví, kde se údaje přečtou a účetní je potvrdí.",
      },
      offline: {
        title: "Funguje bez signálu",
        body: "Fotky počkají v telefonu a odejdou samy, jakmile se vrátí připojení.",
      },
      recent: {
        title: "Nedávno odeslané",
        body: "Seznam vašich posledních dokladů a jak daleko který došel: čte se, čeká na účetní, v účetnictví.",
      },
    },
  },
  miscScan: {
    title: "Netlion Scanner",
    update:
      "Je připravená nová verze Netlion Scanneru. Klepnutím ji stáhnete, pak potvrďte instalaci.",
    offline: "Telefon je offline. Fotěte dál, doklady počkají v telefonu a odejdou samy.",
    photoAlt: "Vyfocený doklad",
    rotate: "Otočit",
    showCleaned: "Zobrazit upravený",
    showOriginal: "Zobrazit originál",
    working: "Pracuji…",
    send: "Odeslat",
    retake: "Vyfotit znovu",
    processing: "Zpracovávám…",
    photograph: "Vyfotit doklad",
    waiting: "Čeká na odeslání: {{count}}",
    tryAgain: "Zkusit znovu",
    recently: "Nedávno odeslané",
    sent: "Odesláno ({{sent}}).",
    sentSome: "Odesláno {{sent}}, čeká {{remaining}}.",
    notSent: "Zatím neodesláno, čeká {{remaining}}. Odejdou samy, jakmile bude signál.",
    processFailed: "Fotku se nepodařilo zpracovat. Zkuste to prosím znovu.",
    saved: "Uloženo. Odesílám…",
    saveFailed: "Nepodařilo se uložit do tohoto telefonu.",
    status: {
      pending: "Čte se",
      extracted: "Přečteno, čeká na účetní",
      failed: "Nepodařilo se přečíst, účetní to doplní",
      filed: "V účetnictví",
      discarded: "Zahozeno",
    },
  },
  miscConnect: {
    title: "Připojit lair",
    description:
      "Terminál žádá o jednání vaším jménem: agenti Hubu na vašem vlastním předplatném Claude.",
    expired: "Tento požadavek vypršel nebo už byl vyřízen. Spusťte znovu <code>lair setup</code>.",
    allowed: "Hotovo. Vraťte se do terminálu, pokračuje sám.",
    denied: "Odmítnuto. Terminál nic nedostane.",
    code: "Kód zobrazený v terminálu",
    onHost: "na {{host}}",
    ableTo: "Bude moct:",
    skillsAbleTo: "Skilly Claude Code (hub) dostanou vlastní klíč a budou moct:",
    warning:
      "Povolte jen tehdy, pokud jste ho spustili vy a kód souhlasí. Kdykoli ho můžete zrušit v Profilu → API tokeny.",
    allow: "Povolit",
    deny: "Zamítnout",
    answerFailed: "Požadavek se nepodařilo vyřídit.",
  },
  miscNav: {
    getLair: "Stáhnout lair",
    getScanner: "Stáhnout Netlion Scanner",
    labels: {
      myPage: "Moje stránka",
      projects: "Projekty",
      workItems: "Tikety",
      wiki: "Wiki",
      ideas: "Nápady",
      testMail: "Testovací e-mail",
      activity: "Aktivita",
      myTime: "Můj čas",
      timeSuggestions: "Návrhy času",
      customers: "Zákazníci",
      billing: "Fakturace",
      aiSpend: "Útrata za AI",
      accounting: "Účetnictví",
      overview: "Přehled",
      invoices: "Faktury",
      recurring: "Opakované",
      expenses: "Výdaje",
      inbox: "Příchozí",
      bank: "Banka",
      missingDocuments: "Chybějící doklady",
      taxDocuments: "Daňové doklady",
      dataBox: "Datová schránka",
      cash: "Pokladna",
      contacts: "Kontakty",
      settings: "Nastavení",
      leavingFakturoid: "Odchod z Fakturoidu",
      books: "Účetní knihy",
      receivables: "Pohledávky",
      journal: "Deník",
      openingBalances: "Počáteční stavy",
      vat: "DPH",
      assets: "Majetek",
      statements: "Výkazy",
      analytics: "Analytika",
      alerts: "Alerty",
      users: "Uživatelé",
      agents: "Agenti",
      suggestions: "Návrhy",
      review: "Kontrola",
      learnings: "Poznatky",
      timeEntries: "Časové záznamy",
      entries: "Záznamy",
      sync: "Synchronizace",
    },
  },
  miscUi: {
    loading: "Načítání",
    clearFilter: "Zrušit filtr",
    include: "Zahrnout",
    exclude: "Vyloučit",
    selectedCount: "vybráno: {{count}}",
    excludedCount: "vyloučeno: {{count}}",
    noChanges: "Žádné změny.",
    copyToast: "Kopírovat obsah oznámení",
    imagePreview: "Náhled obrázku",
  },
  miscLib: {
    genericError: "Něco se pokazilo. Zkuste to prosím znovu.",
    restarting:
      "Hub se restartuje (nejspíš nasazení aktualizace). Nic se neztratilo, zkuste to za chvíli znovu.",
    gitlabRejected: "GitLab změnu odmítl.",
    applyFailed: "Tento návrh se nepodařilo použít.",
    workItemHint: "Tiket",
    overheadHint: "Režie",
    closedSuffix: " (uzavřeno)",
    defaultSuffix: " (výchozí)",
    title: {
      dashboard: "Přehled",
      activity: "Aktivita",
      profile: "Profil",
      reports: "Reporty",
      newTimeEntry: "Nový časový záznam",
      timeEntries: "Časové záznamy",
      newFeature: "Nová funkce",
      newBug: "Nová chyba",
      newTask: "Nový úkol",
      newWorkItem: "Nový tiket",
      workItem: "Tiket",
      workItems: "Tikety",
      newProject: "Nový projekt",
      projectSettings: "Nastavení projektu",
      projectMembers: "Členové projektu",
      releases: "Releasy",
      wiki: "Wiki",
      project: "Projekt",
      projects: "Projekty",
      newCustomer: "Nový zákazník",
      editCustomer: "Upravit zákazníka",
      customer: "Zákazník",
      customers: "Zákazníci",
      idea: "Nápad",
      ideas: "Nápady",
      newInvoice: "Nová faktura",
      invoice: "Faktura",
      billing: "Fakturace",
      myPage: "Moje stránka",
      user: "Uživatel",
      users: "Uživatelé",
      syncRun: "Běh synchronizace",
      sync: "Synchronizace",
    },
  },
};
